<div class="left-content">
  <div class="item">
    <span class="item-title">Run status</span>
    <y42-orchestration-run-status
      class="item-value"
      [statusWithInfo]="{ status: details?.runStatus }"
    ></y42-orchestration-run-status>
  </div>

  <div class="item">
    <span class="item-title">Started at</span>
    <y42-orchestration-run-datetime class="item-value" [datetime]="details?.startedAt"></y42-orchestration-run-datetime>
  </div>

  <div class="item">
    <span class="item-title">Finished at</span>
    <y42-orchestration-run-datetime
      class="item-value"
      [datetime]="details?.finishedAt"
    ></y42-orchestration-run-datetime>
  </div>

  <div class="item">
    <span class="item-title">Duration</span>
    <y42-duration class="item-value" [durationRange]="state.durationRange"></y42-duration>
  </div>

  <div class="item">
    <span class="item-title">Run name</span>
    <y42-orchestration-run-name class="item-value" [nameConfig]="details?.runName"></y42-orchestration-run-name>
  </div>

  <div class="item">
    <span class="item-title">Run id</span>
    <span class="item-value">{{ details?.runId }}</span>
  </div>

  <div class="item">
    <span class="item-title">Triggered by</span>
    <y42-orchestration-triggered-by
      class="item-value"
      [triggeredBy]="details?.triggeredBy"
    ></y42-orchestration-triggered-by>
  </div>
</div>

<div class="inline-block">
  <y42-orchestration-stop-run-button
    *ngIf="state.showStopRunButton && state.runId"
    [runId]="state.runId"
  ></y42-orchestration-stop-run-button>
  <y42-orchestration-show-logs-button *ngIf="state.runId" [runId]="state.runId"></y42-orchestration-show-logs-button>
</div>
